"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexItem = _interopRequireDefault(require("../Layouts/FlexItem"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ColorUtils = require("../../../utils/ColorUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SMALL_CIRCLE_SIZE = 16;
var HEX_6_REGEX = new RegExp(/^#[0-9a-fA-F]{6}$/);
/**
* The Progress component serves two purposes. 1) Display the current progress
* of an operation flow or, 2) can be used to display usage or utilization for a
* particular metric.
*
* @keywords percentage, progress, utilization
*/

var Progress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    _classCallCheck(this, Progress);

    return _possibleConstructorReturn(this, _getPrototypeOf(Progress).apply(this, arguments));
  }

  _createClass(Progress, [{
    key: "renderCircle",

    /**
     * Renders circle SVG
     * @param {string} percentage - percentage circle is filled
     * @param {string} [color] - color of progress
     * @returns {ReactDOM} circle SVG
     */
    value: function renderCircle(percentage, color) {
      var trackProps = {};
      var pathStyleProps = {};

      if (color) {
        var trackColor;

        if (this.props.theme === 'dark') {
          trackColor = (0, _ColorUtils.shadeRGBColor)((0, _ColorUtils.hexToRGB)(color), -0.50);
        } else {
          trackColor = (0, _ColorUtils.shadeRGBColor)((0, _ColorUtils.hexToRGB)(color), 0.70);
        }

        trackProps.style = {
          stroke: trackColor
        };
        pathStyleProps.stroke = color;
      }

      return _react.default.createElement("div", {
        className: "progress-circle"
      }, _react.default.createElement("svg", {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("circle", _extends({
        className: "track",
        r: "8",
        cy: "8",
        cx: "8",
        strokeWidth: "8",
        fill: "none"
      }, trackProps)), _react.default.createElement("circle", {
        className: "path",
        r: "8",
        cy: "8",
        cx: "8",
        strokeWidth: "8",
        fill: "none",
        style: _objectSpread({
          strokeDasharray: this.convertPercentageToLineDash(percentage),
          strokeDashoffset: this.calculateCircumference(SMALL_CIRCLE_SIZE)
        }, pathStyleProps)
      })));
    }
    /**
     * Converts percentage to line dash path value
     * @param {string} percent - percentage circle is filled
     * @returns {number} line dash value
     *
     * Math notes:
     * 50.27 is full circle at 16px size
     * Filled value = 100.27
     * Empty value = 50.27
     * Distance can travel (for line dash to fill circle) = 50
     * To calculate value, find circumference of the circle. e.g.
     * for 16px size the answer is 50.27 and double it to get the path distance.
     */

  }, {
    key: "convertPercentageToLineDash",
    value: function convertPercentageToLineDash(percent) {
      var circumference = this.calculateCircumference(SMALL_CIRCLE_SIZE);
      return percent / 100 * circumference + circumference;
    }
    /**
     * Calculates circumference of a circle using diameter (width of circle)
     * @param {number} diameter - width of circle
     * @returns {number} circumference of a circle
     */

  }, {
    key: "calculateCircumference",
    value: function calculateCircumference(diameter) {
      return Math.PI * diameter;
    }
    /**
     * Renders element with tooltip props
     * @param {object} element - element to add tooltip props to
     * @param {boolean} isLabelVisible - if progress label is visible or not
     * @param {object} tooltipProps - tooltip props
     * @param {string} status - status of progress
     * @param {number} percent -  amount progress is filled
     * @returns {ReactDOM} element with Tooltip wrapper
     */

  }, {
    key: "renderElementWithTooltip",
    value: function renderElementWithTooltip(element, isLabelVisible, tooltipProps, status, percent) {
      if (this.isTooltipNeeded(isLabelVisible, tooltipProps)) {
        return _react.default.createElement(_Tooltip.default, _extends({
          content: this.getStatusLabel(status, percent)
        }, tooltipProps), element);
      }

      return element;
    }
    /**
     * Renders status label string
     * @param {string} status - status of progress
     * @param {number} percent - percent filled of progress
     * @returns {string} status label
     */

  }, {
    key: "getStatusLabel",
    value: function getStatusLabel(status, percent) {
      var _this$props = this.props,
          progressWaitText = _this$props.progressWaitText,
          progressDoneText = _this$props.progressDoneText;

      if (status === Progress.STATUS.WAITING) {
        return progressWaitText;
      } else if (percent === 100) {
        return progressDoneText;
      }

      return "".concat(percent, "%");
    }
    /**
     * Label by default will show only for horizontal progress unless otherwise specified. It will
     * always be visible if it is an element or explicity set to {true}.
     * @param {boolean|node} label - label of progress
     * @param {string} type - type of progress
     * @returns {boolean} true if label is visible
     */

  }, {
    key: "isLabelVisible",
    value: function isLabelVisible(label, type) {
      return label === true || _react.default.isValidElement(label) || (0, _isString2.default)(label) || (0, _isUndefined2.default)(label) && type === Progress.TYPE.HORIZONTAL;
    }
    /**
     * Tooltip by default will show only when there is no label visible unless otherwise specified.
     * It will always be visible if tooltipProps has been set or explicity set to {true}.
     * @param {boolean} isLabelVisible - is label visible
     * @param {object} tooltipProps - tooltip props
     * @returns {ReactDOM} element with Tooltip wrapper
     */

  }, {
    key: "isTooltipNeeded",
    value: function isTooltipNeeded(isLabelVisible, tooltipProps) {
      // Uncontrolled Check (default)
      if ((0, _isEmpty2.default)(tooltipProps) && (0, _isObject2.default)(tooltipProps)) {
        return !isLabelVisible;
      } // Controlled Check (set by user)


      return Boolean(tooltipProps);
    }
    /**
     * Renders progress elemenet
     * @param {string} type - type of progress element to render
     * @param {number} percent - percent filled of progress
     * @param {string} color - color of progress
     * @returns {ReactDOM} Progress Element
     */

  }, {
    key: "renderProgressElement",
    value: function renderProgressElement(type, percent, color) {
      // Progress Circle
      if (type === Progress.TYPE.CIRCLE) {
        return this.renderCircle(percent, color);
      }

      var styleProps = {};

      if (color) {
        styleProps.backgroundColor = color;
        styleProps.boxShadow = "inset 0 0 0 1px ".concat((0, _ColorUtils.hexToRGB)(color, 0.5));
      } // Progress Bar


      return _react.default.createElement(_FlexItem.default, {
        flexGrow: "1",
        className: "progress-bar"
      }, _react.default.createElement("div", {
        className: "progress-fill",
        style: _objectSpread({
          width: "".concat(percent, "%")
        }, styleProps)
      }));
    }
    /**
     * Renders progress label
     * @param {boolean|node} label - label value
     * @param {number} percent - percent filled of progress
     * @param {string} status - status of progress
     * @param {string} width - fixed width of label
     * @param {string} type - type of progress
     * @returns {ReactDOM} Progress label
     */

  }, {
    key: "renderLabel",
    value: function renderLabel(label, percent, status, width, type) {
      if (_react.default.isValidElement(label) || (0, _isString2.default)(label)) {
        return _react.default.createElement("div", {
          className: "progress-label",
          style: {
            width: width
          }
        }, label);
      } else if (this.isLabelVisible(label, type)) {
        return _react.default.createElement("div", {
          className: "progress-label",
          style: {
            width: width
          }
        }, this.getStatusLabel(status, percent));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      // Ignore progressWaitText and progressDoneText since they are used separate in getStatusLabel()
      var _this$props2 = this.props,
          color = _this$props2.color,
          className = _this$props2.className,
          fixedLabelWidth = _this$props2.fixedLabelWidth,
          label = _this$props2.label,
          status = _this$props2.status,
          percent = _this$props2.percent,
          progressWaitText = _this$props2.progressWaitText,
          progressDoneText = _this$props2.progressDoneText,
          theme = _this$props2.theme,
          tooltipProps = _this$props2.tooltipProps,
          type = _this$props2.type,
          props = _objectWithoutProperties(_this$props2, ["color", "className", "fixedLabelWidth", "label", "status", "percent", "progressWaitText", "progressDoneText", "theme", "tooltipProps", "type"]);
      /* eslint-enable */


      return _react.default.createElement(_FlexLayout.default, _extends({
        itemSpacing: "10px",
        alignItems: "center",
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-progress")),
        "data-status": status,
        "data-theme": theme,
        "data-type": type
      }, props), this.renderElementWithTooltip(this.renderProgressElement(type, percent, color), this.isLabelVisible(label, type), tooltipProps, status, percent), this.renderLabel(label, percent, status, fixedLabelWidth, type));
    }
  }]);

  return Progress;
}(_react.default.Component);

exports.default = Progress;
Progress.STATUS = {
  ACTIVE: 'active',
  DANGER: 'danger',
  SUCCESS: 'success',
  WAITING: 'waiting',
  WARNING: 'warning'
};
Progress.TYPE = {
  CIRCLE: 'circle',
  HORIZONTAL: 'horizontal'
};
Progress.defaultProps = {
  status: 'active',
  percent: 0,
  progressDoneText: _I18nManager.default.t('Progress', 'done'),
  progressWaitText: _I18nManager.default.t('Progress', 'wait'),
  theme: 'light',
  type: 'horizontal',
  tooltipProps: {}
};
Progress.propTypes = {
  /**
   * Color of progress bar in hex forrmat. e.g. #FFFFFF. Note: When set color will override the
   * color used by `status` prop.
   * @param {object} props - props of component
   * @param {string} propName - name of prop
   * @param {string} componentName - name of component
   * @returns {Error} Throws error if invallid color is used.
   */
  color: function color(props, propName, componentName) {
    if (!(0, _isUndefined2.default)(props[propName]) && !HEX_6_REGEX.test(props[propName])) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Must be a valid 6 character long\n            hex color code."));
    }
  },

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Set a fixed width for label.
   */
  fixedLabelWidth: _propTypes.default.string,

  /**
   * Label by default will show the current percentage or state of progress. Can set to a value
   * or explicitly set true or false to show default value.
   */
  label: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),

  /**
   * to set the type, options: line,circle
   */
  type: _propTypes.default.oneOf(['circle', 'horizontal']),
  theme: _propTypes.default.oneOf(['light', 'dark']),

  /**
   * to set the completion percentage
   */
  percent: _propTypes.default.number,

  /**
   * To set the status of the progress.
   */
  status: _propTypes.default.oneOf([Progress.STATUS.ACTIVE, Progress.STATUS.DANGER, Progress.STATUS.SUCCESS, Progress.STATUS.WAITING, Progress.STATUS.WARNING]),

  /**
   * To set the text of the progress when the status is 100 percent.
   */
  progressDoneText: _propTypes.default.string,

  /**
   * to set the text of the progress when the status is 'waiting'.
   */
  progressWaitText: _propTypes.default.string,

  /**
   * Add Tooltip. See Tooltip for all available props. On default, tooltip will show if label is
   * not visible. Otherwise, set to {true} to force visibility or {false} to force hidden.
   */
  tooltipProps: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object])
};